module.exports = __webpack_public_path__ + "img/masks.c7d9530f.png";